import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MarketShopInventoryItem } from '@/models'

export const getMarketShopInventoryItemQueryKey = (id?: number) => [
  'useGetMarketShopInventoryItem',
  id,
]

const getMarketShopInventoryItem = async (id?: number): Promise<MarketShopInventoryItem> => {
  const response = await authAPI.get(`/market-shop/product/${id}`)
  return response.data
}

export const useGetMarketShopInventoryItem = (id?: number) => {
  return useQuery({
    enabled: !!id,
    queryFn: () => getMarketShopInventoryItem(id ?? 0),
    queryKey: getMarketShopInventoryItemQueryKey(id ?? 0),
  })
}
